import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as Bearer fallback (cookie may not be set on some browsers/iframes)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("am_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("am_token", t);
  else localStorage.removeItem("am_token");
};

export const getToken = () => localStorage.getItem("am_token");
